import { useRef } from 'react';

// =============================================================================
// useModalSafeClose — fecha modal por clique no overlay SEM o "bug do arrastar".
// Padrão centrao-docs 02-ux-visual §"Modal com overlay".
//
// Bug que evita: usuário seleciona texto DENTRO do modal (mousedown no
// conteúdo), arrasta o mouse pra fora ao selecionar e solta no overlay — o
// browser dispara `click` no ancestral comum (overlay) e fecha o modal por
// engano. Solução: só fecha se o mousedown ORIGINAL foi direto no overlay.
//
// Uso:
//   const safe = useModalSafeClose(() => { if (!salvando) onClose(); });
//   <div className="overlay" {...safe.overlayProps}>
//     <div className="conteudo" {...safe.contentProps}>...</div>
//   </div>
// =============================================================================
export function useModalSafeClose(onFechar) {
  const mouseDownDentro = useRef(false);
  return {
    overlayProps: {
      onMouseDown: () => { mouseDownDentro.current = false; },
      onClick: () => {
        if (!mouseDownDentro.current) onFechar?.();
        mouseDownDentro.current = false;
      },
    },
    contentProps: {
      onMouseDown: (e) => { mouseDownDentro.current = true; e.stopPropagation(); },
      onClick: (e) => e.stopPropagation(),
    },
  };
}
